
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[countryCode]/dispensaries/[stateCodeAndCityName]",
      function () {
        return require("private-next-pages/[countryCode]/dispensaries/[stateCodeAndCityName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[countryCode]/dispensaries/[stateCodeAndCityName]"])
      });
    }
  